import { useStoreState } from '../../../../store/hooks'
import StreakIndicator from '../../components/StreakIndicator'

const PuzzlePracticeStreaks: React.FC = () => {
    const streaks = useStoreState((state) => state.puzzlePracticeView.streaks)
    const puzzleId = useStoreState((state) => state.puzzlePracticeView.puzzle?.id)

    return (
        <StreakIndicator
            currentStreak={streaks?.current ?? 0}
            bestStreak={streaks?.best}
            active={!!streaks?.current}
            variant="practice"
            dataReadySignal={puzzleId}
        />
    )
}

export default PuzzlePracticeStreaks
